import Reveal from "./Reveal";
import { Receipt, CalendarClock, Timer } from "lucide-react";

const USPS = [
  {
    icon: Receipt,
    title: "100% Aftrekbaar",
    description:
      "Onze diensten zijn fiscaal optimaal: afhankelijk van de aftrekbaarheid van het voertuig brengt u de carwash gewoon in kosten.",
  },
  {
    icon: CalendarClock,
    title: "Regelmaat",
    description:
      "2-wekelijks of maandelijks: wij plannen, wij komen, u heeft er geen omkijken naar. Uw vloot blijft permanent in topconditie.",
  },
  {
    icon: Timer,
    title: "Tijdwinst",
    description:
      "The most valuable asset is time. Geen verplaatsingen, geen wachttijden. Uw team blijft productief, wij doen het werk.",
  },
];

export default function Usps() {
  return (
    <section
      id="waarom"
      data-testid="usps-section"
      className="relative bg-white py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <div className="grid lg:grid-cols-12 gap-10 mb-16 md:mb-24">
            <div className="lg:col-span-5">
              <p className="eyebrow mb-5" data-testid="usps-eyebrow">Waarom Cargides Group</p>
              <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight text-cgdark">
                Maximale efficiëntie <br />
                <span className="text-cgprimary italic font-light">voor uw bedrijf.</span>
              </h2>
            </div>
            <div className="lg:col-span-6 lg:col-start-7 flex items-end">
              <p className="text-cgmuted text-base md:text-lg leading-relaxed">
                Wij combineren operationele flexibiliteit met B2B betrouwbaarheid.
                Het resultaat: een vloot die er staat, een team dat tevreden is en
                een agenda die niet onderbroken wordt.
              </p>
            </div>
          </div>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-px bg-cgborder">
          {USPS.map((u, i) => {
            const Icon = u.icon;
            return (
              <Reveal
                key={u.title}
                delay={i * 100}
                className="bg-white p-10 md:p-12 group relative"
                data-testid={`usp-card-${i}`}
              >
                <div className="absolute top-10 right-10 text-cgborder font-heading text-xl">
                  0{i + 1}
                </div>
                <div className="w-14 h-14 flex items-center justify-center bg-cgprimary/10 text-cgprimary mb-8 group-hover:bg-cgprimary group-hover:text-white transition-colors duration-500">
                  <Icon size={26} strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-2xl md:text-3xl font-semibold text-cgdark mb-4 tracking-tight">
                  {u.title}
                </h3>
                <p className="text-cgmuted leading-relaxed text-[15px]">{u.description}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
